import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteCustomerPersona($id: ID!) {
    deleteCustomerPersona(id: $id) {
      id
    }
  }
`;

export const deleteCustomerPersona = (id) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
